// frontend/src/pages/MatchScoring/ScoringHeader.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

function fmtDate(d) {
  if (!d) return '';
  const dt = new Date(d);
  return dt.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
}

export default function ScoringHeader({ match, currentInnings, teamAName, teamBName }) {
  const navigate = useNavigate();
  if (!match) return null;
  const inningsLabel = currentInnings
    ? `Innings ${currentInnings.innings_number}`
    : 'Pre-innings';

  const battingSide = currentInnings?.batting_side; // 'A' | 'B'
  return (
    <div className="sc-header">
      <div className="sc-header-row1">
        <span>
          <button className="sc-header-back" onClick={() => navigate(-1)} aria-label="Back">←</button>
          <span className="sc-header-badge">UCC</span>
          {match.overs ? `${match.overs} over · ` : ''}{inningsLabel}
        </span>
        <span>{fmtDate(match.match_date)}</span>
      </div>
      <div className="sc-header-teams">
        <span className={battingSide === 'A' ? 'sc-header-batting' : ''}>{teamAName || 'Side A'}</span>
        <span className="sc-header-vs">vs</span>
        <span className={battingSide === 'B' ? 'sc-header-batting' : ''}>{teamBName || 'Side B'}</span>
      </div>
    </div>
  );
}
